<template>
  <transition name="slide-in" appear>
    <div class="selection-panel">
      <div class="logo-container">
        <img class="logo" src="../assets/images/ccp-logo.svg" alt="The Capital of Card Payments logo" />
      </div>
      <category-dropdown />
      <location-listing />
    </div>
  </transition>
</template>

<script>
import LocationListing from './LocationListing'
import CategoryDropdown from './CategoryDropdown'
import JsButton from './JsButton'
import BrandLogo from './BrandLogo'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'selection-panel',
  components: { LocationListing, JsButton, BrandLogo, CategoryDropdown },
  computed: {
    ...mapGetters(['getActiveLocation', 'getLocations'])
  },
  methods: {
    ...mapMutations(['clearActiveLocation'])
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  .selection-panel {
    position: relative;
    display: flex;
    flex-direction: row;
    // TODO: Move colours to variables.scss
    background: linear-gradient(-135deg, #E6F5FB 0%, #F8FDFF 100%);
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.20);
    flex-wrap: wrap;
    align-items: flex-end;
    height: calc(100vh - 80px);
    z-index: 2;
  }

  .logo {
    margin: 15px auto;
    width: 180px;

    &-container {
      width: 100%;
      text-align: center;
    }
  }

  .location-listing {
    align-self: flex-end;
  }

  @media #{$breakpoint-md} {
    .slide-in-enter-active,
    .slide-in-leave-active {
      transition: all $animation-timing-fn;
    }
    .slide-in-enter,
    .slide-in-leave-to {
      transform: translateX(-100%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectionPanel.vue